import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// Services
import { MatDialogService } from '@my7n/ui';
import { Router } from "@angular/router";
import { ApplicationInsightsService } from "../../../services/application-insights.service";
import { map } from "rxjs";
import { GlobalAppConfigFacadeService } from "../../../services/facades/global-app-config-facade.service";
import { take } from "rxjs/operators";
import { CookiesService } from "../../../services/cookies.service";


interface IAiSkillsUpdateDialogData {
  userId: string;
  primaryCvId: number;
}

@Component({
    selector: 'ai-skills-update-dialog',
    templateUrl: './ai-skills-update-dialog.component.html',
    styleUrls: ['./ai-skills-update-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AiSkillsUpdateDialogComponent implements OnInit {
  userId: string;

  static readonly AI_SKILLS_COOKIE_NAME = 'ai_skills_update_dialog';

  // 30 days ahead
  expirationDate = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30).toUTCString()


  public loading = false;

  constructor(
    public dialogRef: MatDialogRef<AiSkillsUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IAiSkillsUpdateDialogData,
    public dialog: MatDialogService,
    private appInsightsService: ApplicationInsightsService,
    private router: Router,
    private globalAppConfigFacadeService: GlobalAppConfigFacadeService,
    private cookiesService: CookiesService
  ) { }

  ngOnInit() {
    this.globalAppConfigFacadeService.user$
      .pipe(
        take(1),
        map((user) => user.Id)
      )
      .subscribe((userId) => {
        this.userId = userId;
      })
  }

  onSubmit() {
    this.appInsightsService.trackEvent('BillingOpenSubmittedReport', {
      Message: '[AiSkillsUpdateDialog] User redirected to primary CV',
      Frontend: 'true',
      Service: 'AiSkillsDialog',
      UserId: this.userId
    });

    this.cookiesService.setCookieWithExpirationString(
      AiSkillsUpdateDialogComponent.AI_SKILLS_COOKIE_NAME,
      'true',
      this.expirationDate
    );

    this.router.navigate([`/cv/${this.data.primaryCvId}`]);

    this.dialogRef.close();
  }

  closeDialog() {
    this.appInsightsService.trackEvent('BillingOpenSubmittedReport', {
      Message: '[AiSkillsUpdateDialog] User ignored popup',
      Frontend: 'true',
      Service: 'AiSkillsDialog',
      UserId: this.data.userId
    });


    this.cookiesService.setCookieWithExpirationString(
      AiSkillsUpdateDialogComponent.AI_SKILLS_COOKIE_NAME,
      'false',
      this.expirationDate
    );

    this.dialogRef.close();
  }
}

